import { Component, ElementRef, HostBinding, HostListener, OnDestroy, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { takeWhile } from 'rxjs/operators';
import { SidebarService } from './sidebar.service';
import { FocusTrapFactory } from '@angular/cdk/a11y';
import { ConfirmDialogService } from '@ibe/services/ui';
import { PageScrollService } from 'ngx-page-scroll-core';
import { Router, NavigationEnd } from '@angular/router';
import scrollLock from 'scroll-lock';

@Component({
	selector: 'app-sidebar',
	templateUrl: './sidebar.component.html',
	host: {
		class: 'app-sidebar'
	}
})

export class INDRASidebarComponent implements OnInit, OnDestroy, AfterViewInit {
	@ViewChild('sidebar__content') $sidebarContent: ElementRef;
	@ViewChild('sidebar') $sidebarElem: ElementRef;

	htmlElement = document.getElementsByTagName('html');

	@HostBinding('class.is-open')
	isOpen: boolean;

	@HostBinding('class.is-closing')
	isClosing: boolean;
	didOpen = false;

	@HostBinding('class.is-loading')
	showLoading: boolean;

	@HostBinding('attr.aria-hidden')
	isAriaHidden: boolean;

	isAlive = true;
	lastActiveElement;

	constructor(
		private router: Router,
		private _sidebarService: SidebarService,
		private location: Location,
		private focusTrap: FocusTrapFactory,
		private confirmDialogService: ConfirmDialogService) { }

	/**
	 * Keyboard listener
	 * Navigate on auto-complete using keyboard
	 */
	@HostListener('window:keyup', ['$event'])
	handleKeyboardEvent(event: KeyboardEvent) {
		event.stopPropagation();
		if (this.isOpen && event.key === 'Escape') {
			this.INDRA_handleOverlayClick();
		}
	}

	ngOnInit() {
		this.router.events.subscribe((ev: any) => {
			if (ev instanceof NavigationEnd) {
				if (this.router.url.indexOf('sidebar') > 0) {
					const sidebar = document.getElementById('sidebar').getElementsByClassName('sidebar__body')[0];
					if (sidebar) {
						sidebar.scroll(0, 0);
					}
				}
			}
			return;
		});
		
		this._sidebarService
			.isOpen.pipe(takeWhile(() => this.isAlive))
			.subscribe(
				value => {
					this.isOpen = value;

					if (this.isOpen) {
						this.lastActiveElement = document.activeElement;
						this.$sidebarElem.nativeElement.focus();
						this.didOpen = true;
					} else {
						if (this.didOpen) {
							this.isClosing = true;
							setTimeout(() => {
								this.isClosing = false;
								this.didOpen = false;
							}, 400);
						}

						if (this.confirmDialogService.getIsOpen()) {
							this.confirmDialogService.focusConfirmDialog();
						} else if (this.lastActiveElement) {
							setTimeout(() => {
								this.lastActiveElement.focus();
							}, 400);
						}
					}

					this.isAriaHidden = !value;
				},
				error => console.error(error),
				() => { }
			);

		this._sidebarService
			.showLoading.pipe(takeWhile(() => this.isAlive))
			.subscribe(
				value => {
					this.showLoading = value;
				},
				error => console.error(error),
				() => { }
			);

		this.location.subscribe(currentLocation => {
			if (currentLocation.url.indexOf('sidebar') < 0) {
				this.INDRA_handleOverlayClick();
			} else {
				this.isOpen = true;
			}
		});
	}

	ngAfterViewInit() {
		this.applyA11y();
	}

	ngOnDestroy() {
		this.isAlive = false;
	}

	INDRA_handleClose() {
		this._sidebarService.previousSidebar();
	}

	INDRA_handleOverlayClick() {
		if (!this.showLoading) {
			this.htmlElement[0].classList.remove('no-scroll');
			scrollLock.show();
			// this._sidebarService.closeSidebar(); // sprint 7 client code merge
			this._sidebarService.previousSidebar();
		}
	}

	/* Puts focus on it and trap navigation */
	applyA11y() {
		let focusTrap = this.focusTrap.create(this.$sidebarElem.nativeElement); // creates a focus trap region
		focusTrap.focusInitialElement(); // Moves the focus in the form (by default the first field)
	}

	/**
	 * This is required to fix a Mac OS X Safari bug that occurs on
	 * translated elements.
	 * Check https://stackoverflow.com/questions/28288710/cant-scroll-inside-a-div-after-applying-webkit-transform-in-safari
	 */
	@HostListener('webkitTransitionEnd', ['$event.target'])
	onTransitionEnd(elem: HTMLBaseElement) {
		this.$sidebarElem.nativeElement.style.bottom = 0;
	}
}
